import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

export const ApplicationPage = () => {
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customerid');

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-navy via-brand-navy-light to-brand-navy flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-2xl p-8 md:p-12 text-center">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
        </div>
        
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4">
          Thank You for Choosing Us!
        </h1>
        
        <p className="text-lg text-gray-600 mb-6">
          Your application has been submitted successfully.
        </p>
        
        {customerId && (
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-600 mb-2">Your Customer ID:</p>
            <p className="text-2xl font-bold text-blue-600">{customerId}</p>
          </div>
        )}
        
        <p className="text-gray-600 mb-8">
          Our expert team will review your information and contact you within 24 hours to guide you through the next steps.
        </p>
        
        <div className="space-y-4">
          <div className="flex items-start text-left">
            <CheckCircle className="w-5 h-5 text-green-600 mt-1 mr-3 flex-shrink-0" />
            <p className="text-gray-700">
              <strong>Step 1:</strong> Our team will verify your trademark details
            </p>
          </div>
          <div className="flex items-start text-left">
            <CheckCircle className="w-5 h-5 text-green-600 mt-1 mr-3 flex-shrink-0" />
            <p className="text-gray-700">
              <strong>Step 2:</strong> We'll conduct a comprehensive trademark search
            </p>
          </div>
          <div className="flex items-start text-left">
            <CheckCircle className="w-5 h-5 text-green-600 mt-1 mr-3 flex-shrink-0" />
            <p className="text-gray-700">
              <strong>Step 3:</strong> Your application will be filed with the USPTO
            </p>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            Need immediate assistance? Contact us at{' '}
            <a href="tel:+18776380328" className="text-blue-600 hover:underline">
              +1 (877) 638-0328
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
